module.exports = __webpack_public_path__ + "img/Hiyori1.faa7f820.png";